import { FunctionComponent, h } from 'preact';
import { useCallback, useState } from 'preact/hooks';
import Button from '../../../../components/button/button';
import { useStore } from '../../../../helpers/use-store';
import { isString as _isString } from 'lodash';
import Spinner from '../../../../components/spinner/spinner';
import Translate from '../../../../components/translate/translate';
import { useTranslation } from '../../../../hooks/use-translation';
import { useAriaFocusRef } from '../../../../helpers/aria-helper';

interface Props {
	onMessageSubmit: () => void;
}

const MessageDriver: FunctionComponent<Props> = ({ onMessageSubmit }) => {
	const {
		driverTrackingStore: { sendNote }
	} = useStore();
	const [message, setMessage] = useState(null);
	const [loading, setLoading] = useState(false);
	const [messageError, setMessageError] = useState<string>('');
	const messageDriverRef = useAriaFocusRef<HTMLDivElement>(null);
	const { t } = useTranslation();

	const handleMessage = ({ target }) => {
		setMessage(target.value);
	};

	const submitMessage = useCallback(async () => {
		if (message && _isString(message)) {
			setMessageError('');
			setLoading(true);
			await sendNote(message);
			onMessageSubmit();
			setLoading(false);
		} else {
			setMessageError(t('TRACKING.MESSAGE_DRIVER_FAILED'));
		}
	}, [message]);

	return (
		<div className="message-driver" data-testid="message-driver" ref={messageDriverRef}>
			<div className="title aria-focus" tabIndex={0}>
				{t('TRACKING.MESSAGE_DRIVER')}
			</div>

			<input-component
				className="message-driver-input"
				data-testid="message-driver-input"
				value={message}
				placeholder={t('TRACKING.MESSAGE_DRIVER_PLACEHOLDER')}
				onInput={handleMessage}
				error={messageError}
			/>
			<Button onClick={submitMessage} className="message-driver-send-button" testId="message-driver-send-button">
				<Translate text="TRACKING.SEND" />
				{loading && <Spinner className="message-driver-send-button-spinner" />}
			</Button>
			<Button
				onClick={onMessageSubmit}
				className="message-driver-cancel-button"
				testId="message-driver-cancel-button"
			>
				<Translate text="GLOBAL.CANCEL" />
			</Button>
		</div>
	);
};

export default MessageDriver;
